import { useEffect, useState } from "react";
import moment from "moment";
import { faFileContract } from "@fortawesome/free-solid-svg-icons";
import {
    Content,
    PaginationTableFilter,
    PaginationTable,
    ButtonLink,
    Row,
    Col,
    FloatSelect,
} from "@webtypen/react-components";
import { ContractShiftsEditButton } from "../../components/ContractShiftsEditButton";
import { Page } from "../../components/Page";

export const ContractsOverviewAdmin = () => {
    const [filter, setFilter] = useState({});
    const [isResetting, setIsResetting] = useState(true);
    const [type, setType] = useState("");

    const changeType = (e) => {
        const newValue = e.target.value;
        setIsResetting(true);

        setTimeout(() => {
            setIsResetting(false);
            setType(newValue);
            localStorage.setItem("contracts_list_type", newValue);
        }, 500);
    };

    useEffect(() => {
        const lastType = localStorage.getItem("contracts_list_type");
        setType(lastType && lastType.trim() !== "" ? lastType.trim() : "");
        setIsResetting(false);
    }, []);

    const today = moment().format("YYYY-MM-DD");
    return (
        <Page
            icon={faFileContract}
            title="Aufträge"
            actions={[<ButtonLink to="/contracts/new/edit">Auftrag anlegen</ButtonLink>, <ContractShiftsEditButton />]}
        >
            <Content>
                <Row className="mb-2">
                    <Col width={4}>
                        <FloatSelect placeholder="Anzeigen" value={type} onChange={changeType} disabled={isResetting}>
                            <option value="">Alle</option>
                            <option value="planned">Geplante Aufträge</option>
                            <option value="this_month">Aufträge diesen Monat</option>
                            <option value="history">Vergangene Aufträge</option>
                        </FloatSelect>
                    </Col>
                </Row>

                {isResetting ? null : (
                    <>
                        <PaginationTableFilter
                            definition={{
                                number: { type: "text", label: "Nummer" },
                                customer: { type: "text", label: "Kunde" },
                                customer_contract_number: { type: "text", label: "Auftragsnummer Kunde" },
                            }}
                            filter={filter}
                            setFilter={setFilter}
                        />
                        <PaginationTable
                            url="/api/contracts/list"
                            payload={{ filter: filter, type: type }}
                            tableAttributes={{ className: "valign-middle" }}
                            columns={[
                                { label: "Nummer", attributes: { style: { width: 100 } } },
                                { label: "Auftragsnr. Kunde", attributes: { style: { width: 150 } } },
                                { label: "Kunde" },
                                { label: "Ort" },
                                { label: "Datum", attributes: { style: { width: 120 } } },
                                { label: "Optionen", attributes: { style: { width: 120 }, className: "text-right" } },
                            ]}
                            render={(row, i) => (
                                <tr key={i}>
                                    <td style={{ opacity: today > row.date ? 0.5 : 1 }}>
                                        {row.number ? row.number : "-"}
                                    </td>
                                    <td style={{ opacity: today > row.date ? 0.5 : 1 }}>
                                        {row.customer_contract_number ? row.customer_contract_number : "-"}
                                    </td>
                                    <td style={{ opacity: today > row.date ? 0.5 : 1 }}>
                                        {row.customer_object && row.customer_object.name
                                            ? row.customer_object.name
                                            : "-"}
                                    </td>
                                    <td style={{ opacity: today > row.date ? 0.5 : 1 }}>
                                        {row.address_city && row.address_city ? row.address_city : "-"}
                                    </td>
                                    <td style={{ opacity: today > row.date ? 0.5 : 1 }}>
                                        {row.date ? moment(row.date).format("DD.MM.YYYY") : "-"}
                                    </td>
                                    <td className="text-right">
                                        <ButtonLink to={"/contracts/" + row._id + "/edit"} sm>
                                            Bearbeiten
                                        </ButtonLink>
                                    </td>
                                </tr>
                            )}
                        />
                    </>
                )}
            </Content>
        </Page>
    );
};
